import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ElectronicSignature\SyncElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SyncElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/sync-to-yousign'
*/
const SyncElectronicSignatureToYouSign = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SyncElectronicSignatureToYouSign.url(args, options),
    method: 'post',
})

SyncElectronicSignatureToYouSign.definition = {
    methods: ["post"],
    url: '/api/electronic-signature/{electronicSignature}/sync-to-yousign',
} satisfies RouteDefinition<["post"]>

/**
* @see \App\Http\Controllers\ElectronicSignature\SyncElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SyncElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/sync-to-yousign'
*/
SyncElectronicSignatureToYouSign.url = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { electronicSignature: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { electronicSignature: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            electronicSignature: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        electronicSignature: typeof args.electronicSignature === 'object'
        ? args.electronicSignature.id
        : args.electronicSignature,
    }

    return SyncElectronicSignatureToYouSign.definition.url
            .replace('{electronicSignature}', parsedArgs.electronicSignature.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ElectronicSignature\SyncElectronicSignatureToYouSign::__invoke
* @see app/Http/Controllers/ElectronicSignature/SyncElectronicSignatureToYouSign.php
* @route '/api/electronic-signature/{electronicSignature}/sync-to-yousign'
*/
SyncElectronicSignatureToYouSign.post = (args: { electronicSignature: string | number | { id: string | number } } | [electronicSignature: string | number | { id: string | number } ] | string | number | { id: string | number }, options?: RouteQueryOptions): RouteDefinition<'post'> => ({
    url: SyncElectronicSignatureToYouSign.url(args, options),
    method: 'post',
})

export default SyncElectronicSignatureToYouSign